import React from 'react';
import { theme, commonStyles } from '../styles';
import { skillCategories, programmingLanguages } from '../data';

const SkillsPage = ({ isMobile }) => {
  return (
    <section style={{
      ...commonStyles.page,
      ...(isMobile ? commonStyles.pageMobile : {}),
    }}>
      <h1 style={{
        ...commonStyles.pageTitle,
        ...(isMobile ? commonStyles.pageTitleMobile : {}),
      }}>
        Compétences
      </h1>
      <p style={{
        ...commonStyles.pageSubtitle,
        ...(isMobile ? commonStyles.pageSubtitleMobile : {}),
      }}>
        Technologies et outils avec lesquels j'ai travaillé
      </p>

      {/* Skill Categories Grid */}
      <div style={{
        ...styles.skillsGrid,
        gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(280px, 1fr))',
        gap: isMobile ? '1.25rem' : '2rem',
      }}>
        {skillCategories.map((category, index) => (
          <SkillCategory 
            key={index} 
            category={category} 
            isMobile={isMobile} 
          />
        ))}
      </div>

      {/* Programming Languages Tags */}
      <div style={{
        ...styles.languagesSection,
        marginTop: isMobile ? '2rem' : '3rem',
      }}>
        <h2 style={{
          ...commonStyles.sectionTitle,
          ...(isMobile ? commonStyles.sectionTitleMobile : {}),
        }}>
          Langages de Programmation
        </h2>
        <div style={{
          ...styles.languageTags,
          gap: isMobile ? '0.5rem' : '1rem',
        }}>
          {programmingLanguages.map((lang) => (
            <span 
              key={lang} 
              style={{
                ...styles.languageTag,
                padding: isMobile ? '0.5rem 1rem' : '0.75rem 1.5rem',
                fontSize: isMobile ? '0.85rem' : '1rem',
              }}
            >
              {lang}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

const SkillCategory = ({ category, isMobile }) => (
  <div style={{
    ...styles.skillCategory,
    padding: isMobile ? '1.25rem' : '2rem',
  }}>
    <div style={styles.skillCategoryHeader}>
      <span style={{
        ...styles.skillIcon,
        fontSize: isMobile ? '1.25rem' : '1.5rem',
      }}>
        {category.icon}
      </span>
      <h2 style={{
        ...styles.skillCategoryTitle,
        fontSize: isMobile ? '1.1rem' : '1.25rem',
      }}>
        {category.title}
      </h2>
    </div>
    <div style={{
      ...styles.skillTags,
      gap: isMobile ? '0.4rem' : '0.5rem',
    }}>
      {category.skills.map((skill, i) => (
        <span 
          key={i} 
          style={{
            ...styles.skillTag,
            padding: isMobile ? '0.4rem 0.75rem' : '0.5rem 1rem',
            fontSize: isMobile ? '0.8rem' : '0.9rem',
          }}
        >
          {skill}
        </span>
      ))}
    </div>
  </div>
);

const styles = {
  skillsGrid: {
    display: 'grid',
  },
  skillCategory: {
    background: theme.colors.backgroundCard,
    borderRadius: '16px',
    border: '1px solid rgba(0, 217, 255, 0.1)',
  },
  skillCategoryHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem',
    marginBottom: '1.25rem',
  },
  skillIcon: {},
  skillCategoryTitle: {
    fontWeight: '600',
    color: theme.colors.text,
  },
  skillTags: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  skillTag: {
    background: 'rgba(0, 217, 255, 0.08)',
    color: theme.colors.textMuted,
    borderRadius: '8px',
    fontWeight: '500',
    border: '1px solid rgba(0, 217, 255, 0.15)',
    transition: theme.transition.normal,
  },
  
  // Languages section
  languagesSection: {},
  languageTags: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  languageTag: {
    background: 'rgba(0, 217, 255, 0.1)',
    color: theme.colors.primary,
    borderRadius: '30px',
    fontWeight: '500',
    border: '1px solid rgba(0, 217, 255, 0.3)',
    transition: theme.transition.normal,
  },
};

export default SkillsPage;